import { c as _c } from "react/compiler-runtime";
import { Form, Formik } from 'formik';
import { useContext } from 'react';
import { useHistory } from 'react-router';
import { APIWebhook } from '../../../../../../../../typings/Webhook.interface';
import LINKS from '../../../../../configs/links';
import { cleanseFormErrorObject } from '../../../../../utils/form';
import Alert from '../../../../common/base/Alert';
import Button from '../../../../common/base/Button';
import Container from '../../../../common/base/Container';
import Divider from '../../../../common/base/Divider';
import Link from '../../../../common/base/Link';
import Text from '../../../../common/base/Text';
import { useDialog } from '../../../../common/Dialog';
import { Div } from '../../../../common/helpers/StyledUtils';
import { useToasts } from '../../../../common/Toast';
import { GlobalContext } from '../../../../contexts/GlobalContext';
import { TeamPermission } from '../../../../contexts/TeamPermissionContext';
import ConfirmDeleteDialog from '../ConfirmDeleteDialog';
import resource_details_form_props from '../Forms/resource_details';
import rule_form_props from '../Forms/rules';
import SaveButton from '../SaveButton';
export const ConnectionSettings = t0 => {
  const $ = _c(112);
  const {
    connection,
    mutate
  } = t0;
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  const id = connection.id;
  const {
    addToast
  } = useToasts();
  const showDialog = useDialog();
  const history = useHistory();
  let t1;
  if ($[0] !== HookdeckAPI.webhooks || $[1] !== addToast || $[2] !== id || $[3] !== mutate) {
    t1 = async values => HookdeckAPI.webhooks.update(id, values).then(connection_0 => {
      mutate(connection_0);
      addToast("success", "Connection saved");
      return connection_0;
    }).catch(e => {
      addToast("error", `An error occurred while saving the connection${e.response?.data[0] ? `: ${e.response.data[0]}` : ""}`);
      throw e;
    });
    $[0] = HookdeckAPI.webhooks;
    $[1] = addToast;
    $[2] = id;
    $[3] = mutate;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const onUpdate = t1;
  let t2;
  if ($[5] !== HookdeckAPI.webhooks || $[6] !== addToast || $[7] !== id || $[8] !== mutate) {
    t2 = async () => {
      HookdeckAPI.webhooks.pause(id).then(connection_1 => {
        mutate(connection_1);
        addToast("success", "Connection paused");
      }).catch(() => {
        addToast("error", "Failed to pause connection");
      });
    };
    $[5] = HookdeckAPI.webhooks;
    $[6] = addToast;
    $[7] = id;
    $[8] = mutate;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  const onPause = t2;
  let t3;
  if ($[10] !== HookdeckAPI.webhooks || $[11] !== addToast || $[12] !== id || $[13] !== mutate) {
    t3 = async () => {
      HookdeckAPI.webhooks.unpause(id).then(connection_2 => {
        mutate(connection_2);
        addToast("success", "Connection unpaused");
      }).catch(() => {
        addToast("error", "Failed to pause connection");
      });
    };
    $[10] = HookdeckAPI.webhooks;
    $[11] = addToast;
    $[12] = id;
    $[13] = mutate;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  const onUnpause = t3;
  let t4;
  if ($[15] !== HookdeckAPI.webhooks || $[16] !== addToast || $[17] !== id || $[18] !== mutate) {
    t4 = async () => {
      HookdeckAPI.webhooks.enable(id).then(connection_3 => {
        mutate(connection_3);
        addToast("success", "Connection enabled");
      }).catch(() => {
        addToast("error", "Failed to enable connection");
      });
    };
    $[15] = HookdeckAPI.webhooks;
    $[16] = addToast;
    $[17] = id;
    $[18] = mutate;
    $[19] = t4;
  } else {
    t4 = $[19];
  }
  const onEnable = t4;
  let t5;
  if ($[20] !== HookdeckAPI.webhooks || $[21] !== addToast || $[22] !== id || $[23] !== mutate || $[24] !== showDialog) {
    t5 = async () => {
      showDialog(() => {
        HookdeckAPI.webhooks.disable(id).then(connection_4 => {
          mutate(connection_4);
          addToast("success", "Connection disabled");
        }).catch(() => {
          addToast("error", "Failed to enable connection");
        });
      }, _temp, {
        title: "Disable connection",
        submit_label: "Disable",
        cancel_label: "Cancel",
        message: "By disabling this connection, all existing events will stop delivery and future events won't be processed. Are you sure?"
      });
    };
    $[20] = HookdeckAPI.webhooks;
    $[21] = addToast;
    $[22] = id;
    $[23] = mutate;
    $[24] = showDialog;
    $[25] = t5;
  } else {
    t5 = $[25];
  }
  const onDisable = t5;
  let t6;
  if ($[26] !== HookdeckAPI.webhooks || $[27] !== addToast || $[28] !== history || $[29] !== id || $[30] !== showDialog) {
    t6 = async () => {
      showDialog(() => {
        HookdeckAPI.webhooks.delete(id).then(() => {
          addToast("success", "Connection deleted");
          history.push("/connections");
        }).catch(() => {
          addToast("error", "Failed to delete connection");
        });
      }, _temp2, {
        danger: true,
        title: "Delete connection",
        submit_label: "Delete",
        cancel_label: "Keep connection",
        message: <ConfirmDeleteDialog text="By deleting this connection, no current and future events will be delivered anymore. Are you sure?" />
      });
    };
    $[26] = HookdeckAPI.webhooks;
    $[27] = addToast;
    $[28] = history;
    $[29] = id;
    $[30] = showDialog;
    $[31] = t6;
  } else {
    t6 = $[31];
  }
  const onDelete = t6;
  const t7 = connection.id;
  let t8;
  if ($[32] !== connection) {
    t8 = resource_details_form_props.getInitialValues(connection);
    $[32] = connection;
    $[33] = t8;
  } else {
    t8 = $[33];
  }
  let t9;
  if ($[34] !== HookdeckAPI.webhooks || $[35] !== connection.name || $[36] !== connection.source.id) {
    t9 = values_0 => resource_details_form_props.validate(values_0, name => !name || name === connection.name ? Promise.resolve(false) : HookdeckAPI.webhooks.nameIsUsed(connection.source.id, name), false);
    $[34] = HookdeckAPI.webhooks;
    $[35] = connection.name;
    $[36] = connection.source.id;
    $[37] = t9;
  } else {
    t9 = $[37];
  }
  let t10;
  if ($[38] !== onUpdate) {
    t10 = (values_1, t11) => {
      const {
        resetForm
      } = t11;
      return onUpdate(resource_details_form_props.postprocessValues(values_1)).then(connection_5 => {
        resetForm({
          values: resource_details_form_props.getInitialValues(connection_5)
        });
      });
    };
    $[38] = onUpdate;
    $[39] = t10;
  } else {
    t10 = $[39];
  }
  let t11;
  let t12;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Text bold={true} size="l" m={{
      t: 6,
      b: 4
    }}>Details</Text>;
    t12 = <resource_details_form_props.Fields prefix="" placeholder="" name_prefix="Connection" show_description={true} help="Recommended for API use, or if you have multiple connections with the same source and destination." description_help="Optionally provide a description for this resource." name_required={false} />;
    $[40] = t11;
    $[41] = t12;
  } else {
    t11 = $[40];
    t12 = $[41];
  }
  let t13;
  if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <Form>{t11}{t12}<SaveButton m={{
        t: 5
      }} /></Form>;
    $[42] = t13;
  } else {
    t13 = $[42];
  }
  let t14;
  if ($[43] !== connection.id || $[44] !== t10 || $[45] !== t8 || $[46] !== t9) {
    t14 = <Container medium={true} left={true}><TeamPermission role="member"><Formik key={t7} initialValues={t8} validate={t9} onSubmit={t10}>{t13}</Formik></TeamPermission></Container>;
    $[43] = connection.id;
    $[44] = t10;
    $[45] = t8;
    $[46] = t9;
    $[47] = t14;
  } else {
    t14 = $[47];
  }
  let t15;
  if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <Div m={{
      x: 6,
      t: 10,
      b: 8
    }}><Divider /></Div>;
    $[48] = t15;
  } else {
    t15 = $[48];
  }
  const t16 = connection.id;
  let t17;
  if ($[49] !== connection.rules) {
    t17 = rule_form_props.getInitialValues(connection.rules);
    $[49] = connection.rules;
    $[50] = t17;
  } else {
    t17 = $[50];
  }
  let t18;
  if ($[51] !== t17) {
    t18 = {
      rules: t17
    };
    $[51] = t17;
    $[52] = t18;
  } else {
    t18 = $[52];
  }
  let t19;
  if ($[53] !== HookdeckAPI) {
    t19 = async values_2 => cleanseFormErrorObject({
      rules: await rule_form_props.validate(values_2.rules, HookdeckAPI)
    });
    $[53] = HookdeckAPI;
    $[54] = t19;
  } else {
    t19 = $[54];
  }
  let t20;
  if ($[55] !== onUpdate) {
    t20 = async (values_3, t21) => {
      const {
        resetForm: resetForm_0
      } = t21;
      return onUpdate({
        rules: rule_form_props.postprocessValues(values_3.rules)
      }).then(connection_6 => resetForm_0({
        values: {
          rules: rule_form_props.getInitialValues(connection_6.rules)
        }
      }));
    };
    $[55] = onUpdate;
    $[56] = t20;
  } else {
    t20 = $[56];
  }
  let t21;
  if ($[57] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <Text as="h2" size="l" bold={true} m={0}>Rules</Text>;
    $[57] = t21;
  } else {
    t21 = $[57];
  }
  let t22;
  if ($[58] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <Text muted={true} m={{
      b: 4
    }}>Rules modify the behavior of events being delivered to your destinations.</Text>;
    $[58] = t22;
  } else {
    t22 = $[58];
  }
  let t23;
  if ($[59] !== connection.id || $[60] !== connection.name || $[61] !== connection.source.id) {
    t23 = <rule_form_props.Fields prefix="rules" webhook_id={connection.id} source_id={connection.source.id} connection_name={connection.name} display="full" />;
    $[59] = connection.id;
    $[60] = connection.name;
    $[61] = connection.source.id;
    $[62] = t23;
  } else {
    t23 = $[62];
  }
  let t24;
  if ($[63] !== connection.multipart_compat_enabled) {
    t24 = connection.multipart_compat_enabled && <Alert inline={true} warning={true} m={{
      t: 4
    }}>Multipart bodies are handled as strings on this connection.{" "}<Link primary={true} href={LINKS.product_docs.multipart_migration} target="_blank" rel="noreferrer">Migration guide</Link></Alert>;
    $[63] = connection.multipart_compat_enabled;
    $[64] = t24;
  } else {
    t24 = $[64];
  }
  let t25;
  if ($[65] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <SaveButton m={{
      t: 5
    }} />;
    $[65] = t25;
  } else {
    t25 = $[65];
  }
  let t26;
  if ($[66] !== t23 || $[67] !== t24) {
    t26 = <Form>{t21}{t22}{t23}{t24}{t25}</Form>;
    $[66] = t23;
    $[67] = t24;
    $[68] = t26;
  } else {
    t26 = $[68];
  }
  let t27;
  if ($[69] !== connection.id || $[70] !== t18 || $[71] !== t19 || $[72] !== t20 || $[73] !== t26) {
    t27 = <Container medium={true} left={true}><Formik key={t16} initialValues={t18} validate={t19} onSubmit={t20}>{t26}</Formik></Container>;
    $[69] = connection.id;
    $[70] = t18;
    $[71] = t19;
    $[72] = t20;
    $[73] = t26;
    $[74] = t27;
  } else {
    t27 = $[74];
  }
  let t28;
  if ($[75] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = <Div m={{
      x: 6,
      t: 10,
      b: 8
    }}><Divider /></Div>;
    $[75] = t28;
  } else {
    t28 = $[75];
  }
  let t29;
  if ($[76] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = {
      b: 20
    };
    $[76] = t29;
  } else {
    t29 = $[76];
  }
  const t30 = connection.paused_at ? "Unpause" : "Pause";
  let t31;
  if ($[77] !== t30) {
    t31 = <Text as="h2" size="l" bold={true} m={0}>{t30} connection</Text>;
    $[77] = t30;
    $[78] = t31;
  } else {
    t31 = $[78];
  }
  let t32;
  if ($[79] === Symbol.for("react.memo_cache_sentinel")) {
    t32 = {
      b: 4
    };
    $[79] = t32;
  } else {
    t32 = $[79];
  }
  const t33 = connection.paused_at ? "Unpausing your connection will resume delivery all paused events on this connection" : "Stops all event delivery. Undelivered events will accumulate until unpaused.";
  let t34;
  if ($[80] !== t33) {
    t34 = <Text as="p" muted={true} m={t32}>{t33}</Text>;
    $[80] = t33;
    $[81] = t34;
  } else {
    t34 = $[81];
  }
  const t35 = connection.paused_at ? onUnpause : onPause;
  const t36 = connection.paused_at ? "play_circle" : "pause_circle";
  const t37 = connection.paused_at ? "Unpause" : "Pause";
  let t38;
  if ($[82] !== t35 || $[83] !== t36 || $[84] !== t37) {
    t38 = <Button.Permission outline={true} onClick={t35} icon={t36}>{t37} connection</Button.Permission>;
    $[82] = t35;
    $[83] = t36;
    $[84] = t37;
    $[85] = t38;
  } else {
    t38 = $[85];
  }
  let t39;
  if ($[86] === Symbol.for("react.memo_cache_sentinel")) {
    t39 = {
      t: 10,
      b: 0
    };
    $[86] = t39;
  } else {
    t39 = $[86];
  }
  const t40 = connection.disabled_at ? "Enable" : "Disable";
  let t41;
  if ($[87] !== t40) {
    t41 = <Text as="h2" size="l" bold={true} m={t39}>{t40} connection</Text>;
    $[87] = t40;
    $[88] = t41;
  } else {
    t41 = $[88];
  }
  let t42;
  if ($[89] === Symbol.for("react.memo_cache_sentinel")) {
    t42 = {
      b: 4
    };
    $[89] = t42;
  } else {
    t42 = $[89];
  }
  const t43 = connection.disabled_at ? "Enabling your connection will resume delivery of new events on this connection" : "Stops event delivery and ignores all undelivered attempts.";
  let t44;
  if ($[90] !== t43) {
    t44 = <Text as="p" muted={true} m={t42}>{t43}</Text>;
    $[90] = t43;
    $[91] = t44;
  } else {
    t44 = $[91];
  }
  const t45 = connection.disabled_at ? onEnable : onDisable;
  const t46 = connection.disabled_at ? "add_circle" : "disable";
  const t47 = connection.disabled_at ? "Enable" : "Disable";
  let t48;
  if ($[92] !== t45 || $[93] !== t46 || $[94] !== t47) {
    t48 = <Button.Permission outline={true} onClick={t45} icon={t46}>{t47} connection</Button.Permission>;
    $[92] = t45;
    $[93] = t46;
    $[94] = t47;
    $[95] = t48;
  } else {
    t48 = $[95];
  }
  let t49;
  if ($[96] === Symbol.for("react.memo_cache_sentinel")) {
    t49 = <Text as="h2" size="l" bold={true} m={{
      t: 10,
      b: 0
    }}>Delete connection</Text>;
    $[96] = t49;
  } else {
    t49 = $[96];
  }
  let t50;
  if ($[97] === Symbol.for("react.memo_cache_sentinel")) {
    t50 = <Text as="p" muted={true} m={{
      b: 4
    }}>Permanently deletes this connection, preventing all future event routing.</Text>;
    $[97] = t50;
  } else {
    t50 = $[97];
  }
  let t51;
  if ($[98] !== onDelete) {
    t51 = <Button.Permission danger={true} outline={true} onClick={onDelete} icon="delete">Delete connection</Button.Permission>;
    $[98] = onDelete;
    $[99] = t51;
  } else {
    t51 = $[99];
  }
  let t52;
  if ($[100] !== t31 || $[101] !== t34 || $[102] !== t38 || $[103] !== t41 || $[104] !== t44 || $[105] !== t48 || $[106] !== t51) {
    t52 = <Container medium={true} left={true} m={t29}>{t31}{t34}{t38}{t41}{t44}{t48}{t49}{t50}{t51}</Container>;
    $[100] = t31;
    $[101] = t34;
    $[102] = t38;
    $[103] = t41;
    $[104] = t44;
    $[105] = t48;
    $[106] = t51;
    $[107] = t52;
  } else {
    t52 = $[107];
  }
  let t53;
  if ($[108] !== t14 || $[109] !== t27 || $[110] !== t52) {
    t53 = <Div>{t14}{t15}{t27}{t28}{t52}</Div>;
    $[108] = t14;
    $[109] = t27;
    $[110] = t52;
    $[111] = t53;
  } else {
    t53 = $[111];
  }
  return t53;
};
function _temp() {
  return null;
}
function _temp2() {
  return null;
}